import styled from '@emotion/styled';
import NextImageAvatar from '@cont/MeDashboard/NextImageAvatar';
import { Spacings } from '@styles/index';
import { getBadgeUrl } from '@educator/Container/DPPLeaderboard/utils';
import Image from '@base/Image';

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${(props) =>
    props.$isLarge ? Spacings.SPACING_16B : Spacings.SPACING_12B};
  height: ${(props) =>
    props.$isLarge ? Spacings.SPACING_16B : Spacings.SPACING_12B};
  position: relative;
  border-radius: 50%;
`;

const Badge = styled.div`
  width: ${Spacings.SPACING_19B};
  height: ${Spacings.SPACING_19B};
  position: absolute;
`;

const StyledAvatar = styled(NextImageAvatar)`
  border: 2px solid var(--color-base-1);
`;

const EducatorAvatar = ({
  isLarge,
  url = 'educator/dpp-revamp/edu-icon-placeholder.png',
  badge
}) => {
  const badgeUrl = getBadgeUrl(badge);

  return (
    <Wrapper $isLarge={isLarge}>
      <StyledAvatar size={66} src={url} circular />
      <Badge>
        <Image src={badgeUrl} alt="" layout="fill" />
      </Badge>
    </Wrapper>
  );
};

export default EducatorAvatar;
